const SHORT_NAMES = {
  "3T Change It Or Choose It": "CHOOSE IT",
  "3T Everyday Is A Second Chance": "SECOND CHANCE",
  "3T Gratitude Equals Great Attitude": "GRATITUDE",
  "3T Life Begins Where Fear Ends": "FEAR ENDS",
  "3T One Day Or Day One": "DAY ONE",
  "3T Be Stronger Than Your Excuses": "STRONGER",
  "3T Easy Choices Hard Life": "HARD CHOICES",
  "3T Don't Look Back": "FORWARD",
  "3T Discipline Into Performance": "DISCIPLINE",
  "3T Risk Smart Fail Fast Win Big": "RISK SMART",
  "3T Sometimes Later Becomes Never": "NOW",
};

export function getShortName(fullName) {
  return SHORT_NAMES[fullName] || fullName;
}
